import React from "react";

const ChatHeader = ({
  activeUser,
  onlineSet,
  typing,
  socketConnected,
  currentUser,
}) => {
  const isSelf = activeUser?.id === currentUser?.id;
  const isOnline = isSelf ? true : onlineSet.has(String(activeUser.id));

  const getAvatarUrl = (user) => {
    if (user?.photo) return user.photo;
    return `https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=${encodeURIComponent(
      user?.name || "User"
    )}`;
  };

  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        <img
          src={getAvatarUrl(activeUser)}
          alt={activeUser.name}
          className="w-10 h-10 rounded-full border-2 border-blue-900 object-cover"
        />
        <span
          className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white shadow-md ${
            isOnline ? "bg-green-500" : "bg-gray-400"
          }`}
        />
      </div>
      <div>
        <h2 className="text-base font-bold text-blue-900">{activeUser.name}</h2>

        <p className="text-xs text-blue-800 font-semibold">
          {typing ? (
            <span className="italic">✏️ typing...</span>
          ) : isOnline ? (
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-green-500"></span>
              Online
            </span>
          ) : (
            "Offline"
          )}
        </p>
      </div>
    </div>
  );
};

export default ChatHeader;
